import { url } from "../utils/config";
import axios from "axios";
import Table from "../reusable_components/Table";
import { toast } from "react-toastify";
import { btnGreen, btnRed, title } from "../utils/style";

function TransferRequest() {

    async function approveTransferRequest(id) {
        try {
            const reqUrl = url + '/approve_inventory_tranfer/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 })
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    async function rejectTransferRequest(id) {
        try {
            const reqUrl = url + '/reject_inventory_tranfer/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            toast.success(data.message, { autoClose: 3000 })
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    const options = [
        {
            header: 'Location',
            key: 'to',
        },
        {
            header: 'Requested By',
            key: 'requestedBy',
        },
        {
            header: 'Equipment Name',
            key: 'equipmentId',
        },
        {
            header: 'Quantity',
            key: 'quantity',
        },
        {
            header: 'Transfer Note',
            key: 'note'
        },
        {
            header: 'Action',
            render: (data) => {
                return(
                    <>
                        <button className={btnGreen} onClick={() => approveTransferRequest(data.id)}>Transfer</button>
                        <button className={btnRed} onClick={() => rejectTransferRequest(data.id)}>Reject</button>
                    </>
                )
             },
        }
    ]

    const excludeFilter = ['Transfer Note', 'Action']

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Inventory Transfer</div>
            
            <Table 
                options={options} 
                url={url + '/inventory_transfer_requests'} 
                pagination 
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default TransferRequest;